/**
 * 微信登录配置
 * 注意：在新的OAuth2.0流程中，appId和redirectUri由后端提供，前端不需要配置
 */
export const wechatConfig = {
  // 微信登录JS SDK地址 - 使用HTTPS协议避免Mixed Content错误
  jsSDK: 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js',
  
  // 授权作用域 - 固定值
  scope: 'snsapi_login',
  
  // 样式配置
  style: {
    theme: 'black', // black 或 white
    width: '280px',
    height: '280px'
  }
};

/**
 * 生成微信登录state参数（防CSRF攻击）
 * 注意：在新流程中，state由后端生成，此函数仅用于降级场景
 */
export function generateWechatState() {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 15);
  return `${timestamp}_${random}`;
}

/**
 * 验证微信登录state参数
 */
export function validateWechatState(state) {
  if (!state) return false;
  
  const parts = state.split('_');
  if (parts.length !== 2) return false;
  
  const timestamp = parseInt(parts[0]);
  const now = Date.now();
  
  // state有效期为10分钟
  return (now - timestamp) < 10 * 60 * 1000;
}

/**
 * 保存微信登录state
 */
export function saveWechatState(state) {
  sessionStorage.setItem('wechat_login_state', state);
  
  // 同时保存当前页面URL，用于登录成功后跳转
  const currentPath = window.location.pathname + window.location.search;
  sessionStorage.setItem('wechat_login_redirect', currentPath);
}

/**
 * 获取登录重定向URL
 */
export function getLoginRedirectUrl() {
  return sessionStorage.getItem('wechat_login_redirect') || '/';
}

/**
 * 清除微信登录state
 */
export function clearWechatState() {
  sessionStorage.removeItem('wechat_login_state');
  sessionStorage.removeItem('wechat_login_redirect');
} 